// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__YnaC9","content":"Modal_content__vP6CM"};